import { getStoredAuthHeaders, ApiError, updateStoredAuthHeadersFromResponse } from './client';

const CELEPUS_API_URL = process.env.REACT_APP_CELEPUS_API_URL ?? '';

// celepus-api resolves this app's DeviseTokenAuth headers via a
// server-to-server call to celepus-sso, and relays back whatever rotated
// headers SSO returned — those have to be captured here exactly like
// direct SSO responses, or the stored token goes stale (see client.ts).
const celepusApiFetch = async (path: string, options: RequestInit = {}): Promise<any> => {
  const storedHeaders = getStoredAuthHeaders();

  const response = await fetch(`${CELEPUS_API_URL}${path}`, {
    ...options,
    headers: {
      'Content-Type': 'application/json',
      ...(storedHeaders ?? {}),
      ...(options.headers as Record<string, string> | undefined),
    },
  });

  updateStoredAuthHeadersFromResponse(response);

  const text = await response.text();
  const body = text ? JSON.parse(text) : null;

  if (!response.ok) {
    throw new ApiError(response.status, body);
  }

  return body;
};

export {
  celepusApiFetch,
};
